import React from 'react';
import type { ReactNode } from 'react';
import { useCssHandles } from '../../../utils/functions';

const SELLERS_CSS_HANDLES = ['sellerHead'] as const;

interface Props {
	children: ReactNode;
	componentId?: string;
	blockClass?: string;
}

function SellerHead({ children, componentId, blockClass }: Props) {
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, SELLERS_CSS_HANDLES, blockClass);

	return (
		<div
			data-selection={componentId}
			className={`${handles.sellerHead} mh7 mt1 justify-between-s dn-s flex-m items-center-s br2 bg-muted-3 hover-bg-muted-3 active-bg-muted-3 c-on-muted-3 hover-c-on-muted-3 active-c-on-muted-3 dib`}
		>
			{children}
		</div>
	);
}

export default SellerHead;
